import styled from 'styled-components';

type Prop = {};

export default styled.section<Prop>``;

export const ContentStyled = styled.p`
  margin-bottom: 31px;
  color: var(--black);
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  padding-left: 24px;
`;
